<template>
  <div class="page_five">
    <div class="page_two_title flex-eju-center">
      <div class="title_word">
        数字化营销
        <!-- <div class="line_block"></div> -->
      </div>
    </div>
    <div class="page_tip">
      <div>
        跟客流程细粒度、数据化视图呈现，实时查看、反馈、总结，智能提升跟客质量，实现机脑协同
      </div>
      <div>
        打造的“扩大-识别-转化-沉淀”一体化解决方案，帮助行业实现更精准的客户触达，更有效的客户沉淀、更精细的过程管理和更可持续的运营服务
      </div>
    </div>
    <div class="page_four_content flex-eju-center">
      <div class="content_left animate__animated animate__fadeInLeft">
        <div
          class="left_item"
          :class="[index === activeIndex ? 'active' : '']"
          v-for="(item, index) in listData"
          :key="index"
          @click="changeItem(index)"
        >
          <div class="title">{{ item.title }}</div>
          <div class="tip" v-for="(item, i) in item.tip" :key="i">
            {{ item }}
          </div>
        </div>
      </div>
      <div class="content_right">
        <div v-for="(item, index) in listData" :key="index">
          <div
            class="right_item animate__animated"
            :class="[item.animate]"
            v-if="index === activeIndex"
          >
            <img :src="item.img" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    activePageIndex: {
      type: Number,
      default: 0
    }
  },
  watch: {
    activePageIndex: {
      handler: function(val) {
        if (val === 4) {
          this.showPage = true
        }
      },
      deep: true,
    }
  },
  data() {
    return {
      showPage: false,
      activeIndex: 0,
      listData: [
        {
          title: "客户资源企业化",
          tip: [
            "企业拥有客户微信、电话号码",
            "企业管理和分配客户与员工关系",
            "如离职客户继承、在职客户转移",
          ],
          img: require("@/assets/svg/page_5/P1.svg"),
          animate: "animate__fadeInRight",
        },
        {
          title: "客户轨迹可视化",
          tip: [
            "客户整个生命周期日志全纪录",
            "重要轨迹监控",
            "客户行为反哺销售策略",
          ],
          img: require("@/assets/svg/page_5/P2.svg"),
          animate: "animate__fadeInRight",
        },
        {
          title: "员工绩效体系化",
          tip: [
            "员工与客户的互动全程可追溯",
            "朋友圈、群发任务分配制",
            "核心节点管控",
          ],
          img: require("@/assets/svg/page_5/P3.svg"),
          animate: "animate__fadeInRight",
        },
      ],
    };
  },
  methods: {
    changeItem(index) {
      if (this.activeIndex === index) return;
      this.activeIndex = index;
    },
  },
};
</script>
<style lang="less" scoped>
.page_five {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-top: 10%;
  position: relative;
  overflow: hidden;
  &::before {
    position: absolute;
    content: " ";
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url("../../../assets/svg/chart-bg-deep.svg");
    background-size: 100%;
    background-position: center;
    opacity: 0.05;
  }
  .page_two_title {
    font-weight: 300;
    font-size: 40px;
    line-height: 56px;
    color: #212538;
    // margin-bottom: 16px;
    .title_word {
      position: relative;
      padding-bottom: 16px;
      .line_block {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 4px;
        background: linear-gradient(105.88deg, #007aff 0%, #0057ff 100%);
        border-radius: 4px;
      }
    }
  }
  .page_tip {
    font-size: 18px;
    line-height: 32px;
    color: #212538;
    text-align: center;
  }
  .page_four_content {
    position: relative;
    .left_item {
      width: 298px;
      height: 108px;
      box-sizing: border-box;
      border-left: 2px solid rgba(33, 37, 56, 0.1);
      padding-left: 20px;
      color: #212538;
      margin: 40px 0;
      cursor: pointer;
      &.active {
        border-color: #007aff;
      }
      .title {
        font-weight: 500;
        font-size: 18px;
        line-height: 28px;
        margin-bottom: 8px;
      }
      .tip {
        font-size: 14px;
        line-height: 24px;
        color: rgba(33, 37, 56, 0.7);
      }
    }
  }
  .content_right {
    // margin-left: 60px;
    .right_item {
      width: 796px;
      height: 480px;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }
}
</style>
